import tns from "@/lib/tiny-slider/tiny-slider.js";

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.control-call-to-action').forEach(function (gallery) {
        var containerEl = gallery.querySelector('.call-to-action-image-slider');
        if (!containerEl) return;

        var slider = tns({
            container: containerEl,
            items: 1,
            slideBy: 1,
            nav: false,
            hasControls: true,
            autoplay: false,
            speed: 300,
            prevButton: gallery.querySelector('.call-to-action-slider-arrows .left-arrow'),
            nextButton: gallery.querySelector('.call-to-action-slider-arrows .right-arrow')
        });
    });
});
